<template>
    <fieldset :class="`${classFieldset} ${!noMarginTop ? 'mt-4' : ''}`">
        <legend v-if="title.length > 0 || showLegend">
            <div>
                <template v-if="$scopedSlots.leading">
                    <span class="pr-2">
                        <slot name="leading" />
                    </span>
                </template>

                <span>{{ title }}</span>

                <template v-if="$scopedSlots.trailing">
                    <span class="pl-2">
                        <slot name="trailing" />
                    </span>
                </template>
            </div>

            <div v-if="subtitle">
                <small>{{ subtitle }}</small>
            </div>
        </legend>

        <slot />
    </fieldset>
</template>

<script>
export default {
    computed: {
        classFieldset(){
            return `rkm-area ${this.type} variant-${this.color} heading-${this.titleHeading}`
        },
    },
    props: {
        color: { type: String, default: 'primary' },
        noMarginTop: { type: Boolean },
        showLegend: { type: Boolean },
        subtitle: { type: String },
        title: { type: String, default: '' },
        type: { type: String, default: 'section' },
    },
}
</script>

<style scoped>
fieldset > *:last-child .form-group {
    margin-bottom: 0;
}
fieldset {
    padding: 0.5rem 0 0 0;
}
legend {
    color: #555;
    font-size: 1.05em;
    line-height: 20px;
    margin: 0;
    text-transform: uppercase;
    width: auto;
}
.rkm-area button {
    margin: -13px 0 -7px 0;
    vertical-align: middle;
}
.fieldset {
    border-radius: 7px;
    border: 2px solid #555;
    margin: 7px 0;
    padding: 15px;
}
.fieldset legend {
    padding: 0 1rem;
}
.section legend {
    border-bottom: 2px solid #555;
    font-size: 1.05em;
    font-weight: 500;
    padding: 10px 0;
    text-transform: uppercase;
    width: 100%;
}
.section.heading-2 > legend span,
.section.heading-3 > legend span {
    font-weight: 400;
}
.section.heading-3 > legend > .subtitle {
    font-size: 16px;
}
.section.heading-2 > legend {
    border-bottom-width: 1px;
}
.section.heading-3 > legend {
    border-bottom: none;
}
.variant-primary legend {
    color: #007bff;
}
.variant-primary.fieldset {
    border-color: #007bff;
}
.variant-primary.section legend {
    border-bottom-color: #007bff;
}
.variant-gestante legend {
    color: var(--gestante-primary);
}
.variant-gestante .fieldset {
    border-color: var(--gestante-primary);
}
.variant-gestante.section legend {
    border-color: var(--gestante-primary);
}
</style>